import {Product} from "@proto/chatbot/v1alpha/chatbot"
import ProductsMessage from "./ProductsMessage"

interface IProps {
    products?: Product[]
}

const SponsoredProductList = ({products}: IProps) => {
    if (!products) {
        return
    }

    return <ProductsMessage products={products} />
}

export default SponsoredProductList
